import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Media,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";

const Stageslist = () => {
  const [stages, setStages] = useState([]);
  const [modal, setModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStage, setSelectedStage] = useState({
    id: "",
    title: "",
    total_tokens: "",
    base_price: "",
    start_date: "",
    end_date: "",
  });

  // Fetch stages from the API
  useEffect(() => {
    const fetchStages = async () => {
      try {
        const token = localStorage.getItem("token"); // Get token from localStorage

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/stages`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Add Authorization header
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

 // Handle new tokenomics structure
        if (data.tokenomics && data.tokenomics.length > 0) {
          // Convert tokenomics data to stages format for display
          const stagesData = data.tokenomics.map((tokenomics, index) => ({
            id: tokenomics._id,
            title: `Stage ${tokenomics.stage}`,
            total_tokens: tokenomics.tokensToSell,
            base_price: tokenomics.priceUSD,
            tokensSold: tokenomics.tokensSold,
            usdCap: tokenomics.usdCap,
            usdRaised: tokenomics.usdRaised,
            isCurrent: tokenomics.isCurrent,
            createdAt: tokenomics.createdAt,
            updatedAt: tokenomics.updatedAt,
            // Use existing dates if available, else placeholders
            start_date: tokenomics.startAt || tokenomics.createdAt,
            end_date: tokenomics.endAt || new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
          }));

          stagesData.sort((a, b) => {
            const stageNumberA = parseInt(a.title.split(" ")[1]);
            const stageNumberB = parseInt(b.title.split(" ")[1]);
            return stageNumberA - stageNumberB;
          });

          setStages(stagesData);
        } else if (response.data?.stages) {
           // Fallback to old structure
          const stagesData = response.data.stages ? response.data.stages : [];

          // Sort stages by title (assuming title format "Stage X")
                  stagesData.sort((a, b) => {
            const stageNumberA = parseInt(a.title.split(" ")[1]);
            const stageNumberB = parseInt(b.title.split(" ")[1]);
            return stageNumberA - stageNumberB;
          });

          setStages(stagesData);
        }
      } catch (error) {
        console.error("Error fetching stages:", error);
      }
    };
    fetchStages();
  }, []);

    // Handle stage deletion
  const handleDeleteStage = async (id) => {
    if (window.confirm("Are you sure you want to delete this stage?")) {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}/stages/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.status === 200) {
          alert(response.data.message);
          setStages((prevStages) =>
            prevStages.filter((stage) => stage.id !== id),
          );
        }
      } catch (error) {
        console.error("Error deleting stage:", error.message);
        
        // Handle authentication errors
        if (error.response?.status === 401 || error.response?.status === 403) {
          localStorage.removeItem("token");
          window.location.href = "/login";
          return;
        }

        alert("Failed to delete the stage. Please try again.");
      }
    }
  };

  // UPDATED: Formats dates so they show up in the modal input fields
  const handleEditStage = (stage) => {
    setSelectedStage({
      ...stage,
      start_date: stage.start_date ? stage.start_date.split("T")[0] : "",
      end_date: stage.end_date ? stage.end_date.split("T")[0] : "",
    });
    toggleModal();
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  // UPDATED: Correctly maps date names to 'startAt' and 'endAt' for the backend
  const handleUpdateStage = async () => {
    try {
      const token = localStorage.getItem("token");

      const updateData = {
        stage: parseInt(selectedStage.title.split(" ")[1]) || selectedStage.stage,
        tokensToSell: Number(selectedStage.total_tokens),
        priceUSD: Number(selectedStage.base_price),
        soft_cap: Number(selectedStage.soft_cap),
        hard_cap: Number(selectedStage.hard_cap),
        min_per_transaction: Number(selectedStage.min_per_transaction),
        max_per_transaction: Number(selectedStage.max_per_transaction),
        // Aligning with your backend schema names
        startAt: selectedStage.start_date ? new Date(selectedStage.start_date).toISOString() : null,
        endAt: selectedStage.end_date ? new Date(selectedStage.end_date).toISOString() : null,
      };

      console.log("Mapped update data:", updateData);

      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/stages/${selectedStage.id}`,
        updateData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200) {
        alert(response.data.message);
        setStages((prevStages) =>
          prevStages.map((stage) =>
            stage.id === selectedStage.id ? { ...selectedStage } : stage
          )
        );
        toggleModal();
      }
    } catch (error) {
      console.error("Error updating stage:", error.message);
      if (error.response?.status === 401 || error.response?.status === 403) {
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }
      alert("Failed to update the stage. Please try again.");
    }
  };

  const filteredStages = stages.filter((stage) =>
    stage.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const currentDate = new Date();

  const isCurrentStage = (stage) => {
    if (stage.isCurrent !== undefined) {
      return stage.isCurrent;
    }
    const startDate = new Date(stage.start_date);
    const endDate = new Date(stage.end_date);
    return currentDate >= startDate && currentDate <= endDate;
  };

  return (
    <Container
      style={{
        border: "none",
        backgroundColor: "rgba(1,1,1,0.2)",
        width: "100%",
        padding: "0",
        maxWidth: "100%",
      }}
    >
      <Row
        style={{
          border: "none",
          backgroundColor: "rgba(1,1,1,0.2)",
          margin: "0",
        }}
      >
        <div style={{ width: "100%" }}>
          <Card
            style={{
              border: "none",
              backgroundColor: "rgba(1,1,1,0.2)",
              width: "100%",
            }}
          >
            <CardHeader
              className="border-0"
              style={{ backgroundColor: "rgba(1,1,1,0.2)", border: "none" }}
            >
              <h3
                className="mb-0"
                style={{
                  color: "white",
                  fontSize: "40px",
                  fontWeight: "bolder",
                }}
              >
                Stages List
              </h3>
            </CardHeader>

            <div style={{ padding: "10px" }}>
              <Input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search by stage title"
                style={{
                  width: "100%",
                  background: "black",
                  color: "white",
                  padding: "10px",
                  fontSize: "1.1rem",
                  borderRadius: "5px",
                  outline: "none",
                  border: "none",
                }}
              />
            </div>
            <br />

            <Table
              responsive
              style={{
                width: "100%",
                tableLayout: "auto",
                borderCollapse: "collapse",
                overflowX: "auto",
              }}
            >
              <thead>
                <tr>
                  <th style={{ color: "white", fontSize: "1.1rem", backgroundColor: "rgba(1,1,1,0.2)", border: "none" }}>Stage</th>
                  <th style={{ color: "white", fontSize: "1.1rem", backgroundColor: "rgba(1,1,1,0.2)", border: "none" }}>Total Tokens</th>
                  <th style={{ color: "white", fontSize: "1.1rem", backgroundColor: "rgba(1,1,1,0.2)", border: "none" }}>Base Price</th>
                  <th style={{ color: "white", fontSize: "1.1rem", backgroundColor: "rgba(1,1,1,0.2)", border: "none" }}>Start Date</th>
                  <th style={{ color: "white", fontSize: "1.1rem", backgroundColor: "rgba(1,1,1,0.2)", border: "none" }}>End Date</th>
                  <th style={{ color: "white", fontSize: "1.1rem", backgroundColor: "rgba(1,1,1,0.2)", border: "none" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredStages.map((stage) => (
                  <tr
                    key={stage.id}
                    style={{
                      border: "none",
                      backgroundColor: isCurrentStage(stage)
                        ? "rgb(255, 176, 0, 0.4)"
                        : "transparent",
                    }}
                  >
                    <td style={{ color: "white", border: "none" }}>{stage.title}</td>
                    <td style={{ color: "white", border: "none" }}>{Number(stage.total_tokens).toLocaleString()}</td>
                    <td style={{ color: "white", border: "none" }}>{stage.base_price}</td>
                    <td style={{ color: "white", border: "none" }}>{new Date(stage.start_date).toLocaleDateString()}</td>
                    <td style={{ color: "white", border: "none" }}>{new Date(stage.end_date).toLocaleDateString()}</td>
                    <td style={{ color: "white", border: "none" }}>
                      <Button color="dark" onClick={() => handleDeleteStage(stage.id)}>Delete</Button>{" "}
                      <Button color="dark" onClick={() => handleEditStage(stage)}>Edit</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
        </div>
      </Row>

      {/* Edit Stage Modal */}
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Stage</ModalHeader>
        <ModalBody>
          <div>
            <label style={{ color: "black" }}>Stages</label>
            <Input
              type="text"
              value={selectedStage.title}
              onChange={(e) => setSelectedStage({ ...selectedStage, title: e.target.value })}
              placeholder="Stage Title"
            />
            <label style={{ color: "black" }}>Total Tokens</label>
            <Input
              type="number"
              value={selectedStage.total_tokens}
              onChange={(e) => setSelectedStage({ ...selectedStage, total_tokens: e.target.value })}
              placeholder="Total Tokens"
            />
            <label style={{ color: "black" }}>Base Price</label>
            <Input
              type="number"
              value={selectedStage.base_price}
              onChange={(e) => setSelectedStage({ ...selectedStage, base_price: e.target.value })}
              placeholder="Base Price"
            />
            <label style={{ color: "black" }}>Min per Transaction</label>
            <Input
              type="number"
              value={selectedStage.min_per_transaction}
              onChange={(e) => setSelectedStage({ ...selectedStage, min_per_transaction: e.target.value })}
              placeholder="Min per Transaction"
            />
            <label style={{ color: "black" }}>Max per Transaction</label>
            <Input
              type="number"
              value={selectedStage.max_per_transaction}
              onChange={(e) => setSelectedStage({ ...selectedStage, max_per_transaction: e.target.value })}
              placeholder="Max per Transaction"
            />
            <label style={{ color: "black" }}>Soft Cap</label>
            <Input
              type="number"
              value={selectedStage.soft_cap}
              onChange={(e) => setSelectedStage({ ...selectedStage, soft_cap: e.target.value })}
              placeholder="Soft Cap"
            />
            <label style={{ color: "black" }}>Hard Cap</label>
            <Input
              type="number"
              value={selectedStage.hard_cap}
              onChange={(e) => setSelectedStage({ ...selectedStage, hard_cap: e.target.value })}
              placeholder="Hard Cap"
            />
            <label style={{ color: "black" }}>Start Date</label>
            <Input
              type="date"
              value={selectedStage.start_date}
              onChange={(e) => setSelectedStage({ ...selectedStage, start_date: e.target.value })}
            />
            <label style={{ color: "black" }}>End Date</label>
            <Input
              type="date"
              value={selectedStage.end_date}
              onChange={(e) => setSelectedStage({ ...selectedStage, end_date: e.target.value })}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="dark" onClick={toggleModal}>Cancel</Button>
          <Button color="dark" onClick={handleUpdateStage}>Save Changes</Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

export default Stageslist;